<script setup lang="ts">
  import PdfView from "~/components/Molecules/PdfView.vue";
  interface Props {
    isOpen: boolean;
    url: string;
    isSignedCookie?: boolean; // 署名がCookieかどうか
  }
  const props = defineProps<Props>();

  interface Emits {
    (event: "update:isOpen", isOpen: boolean): void;
  }
  const emit = defineEmits<Emits>();

  const pdfView = ref<InstanceType<typeof PdfView> | null>(null);

  const computedIsOpen = computed<boolean>({
    get: () => props.isOpen,
    set: value => {
      emit("update:isOpen", value);
    },
  });

  const clickClose = () => {
    computedIsOpen.value = false;
  };

  // レスポンシブ対応
  const isSp = isSpDisplayRef();

  const isLoading = ref(true);

  // VuePdfApp はファイルを読み込む際に cookie 送信をサポートしないため、
  // 署名付き cookie を送信するために fetch でデータを取得してそれを渡す
  const pdfData = ref();
  if (props.isSignedCookie) {
    fetch(props.url, { credentials: "include" }).then(async response => {
      pdfData.value = await response.arrayBuffer();
      isLoading.value = false;
    });
  }
</script>

<template>
  <v-dialog v-model="computedIsOpen" fullscreen scrim="transparent">
    <div class="d-flex flex-column justify-center dialog-body">
      <v-progress-circular v-if="isLoading" class="mx-auto" indeterminate color="white"></v-progress-circular>
      <MoleculesPdfView
        v-if="!isLoading && pdfData"
        ref="pdfView"
        class="mt-12 pdf-body"
        :data="pdfData"
        :is-open-sidebar="!isSp"
      />
      <div class="close-button d-flex justify-center align-center">
        <v-icon size="24px" color="white" icon="$mdiClose" @click="clickClose"></v-icon>
      </div>
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .dialog-body {
    color: rgb(var(--v-theme-text));
    background-color: rgba(0, 0, 0, 0.8);
    width: 100%;
    height: 100%;
  }
  .pdf-body {
    height: calc(100% - 24px);
  }
  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
  }
  .close-button {
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    position: absolute;
    right: 15px;
    top: 25px;
    transform: translate(0%, -50%);
    -webkit-transform: translate(0%, -50%);
    -ms-transform: translate(0%, -50%);
  }

  :deep(#vuePdfApp) {
    #toolbarContainer,
    #toolbarSidebar {
      background-color: black !important;
    }
    #toolbarSidebar,
    #secondaryToolbarToggle,
    .verticalToolbarSeparator {
      display: none;
    }
    #sidebarContent,
    #sidebarContainer {
      background-color: #00000069 !important;
    }
    #sidebarContent {
      top: 0 !important;
    }
    #viewer {
      margin-left: -18px !important;
      background-color: #2d2d2d !important;
    }
    .pdf-app[class] .dropdownToolbarButton:hover,
    .pdf-app[class] .overlayButton,
    .pdf-app[class] .secondaryToolbarButton:focus,
    .pdf-app[class] .secondaryToolbarButton:hover,
    .pdf-app[class] .toolbarButton:focus,
    .pdf-app[class] .toolbarButton:hover,
    .vue-pdf-app-icon:hover[class] {
      color: rgb(var(--v-theme-monochrome-01)) !important;
    }
    .toolbarButton.toggled {
      background-color: inherit !important;
    }
    .toolbarField,
    .dropdownToolbarButton > select {
      background-color: #2d2d2d !important;
    }
    .toolbar {
      z-index: 1;
    }
  }
</style>
